import * as React from 'react';
import { Field } from '../../types/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { memo } from 'react';


type InfoDrawerProps = {
  field: Field | null;
  showClose?: boolean;
  onClose: () => void;
  children: React.ReactNode;
  side?: String | null;
  setShowDownload?: Function;
};

const InfoDrawer = ({
  field,
  showClose=true,
  onClose,
  children,
  side="left",
  setShowDownload,
}: InfoDrawerProps) => {
  return (
    <div className="d-flex flex-column h-100">
      { (field || showClose) &&
        <>
          <div className={`align-items-center d-flex justify-content-between pl-1 pr-2 pt-2 pb-0 ${side === "right" ? " abs-placement-chevron" : " "}`}>
            <h4 className="m-0 ml-2 text-lg font-weight-bold">{field?.name}</h4>
              <div>
              { setShowDownload && 
                <Button 
                  className="rounded-circle" variant="light" size="sm" title="Download map data" 
                  onClick={(e: any) => {
                    if (setShowDownload){
                      setShowDownload((prevState:boolean) => {
                        return !prevState;
                      });
                    }
                  }}
                  style={{cursor:'pointer', height:'30px', width:'30px', padding:'0.25rem 0.375rem'}}
                >
                  <FontAwesomeIcon icon={faCloudDownloadAlt} />
                </Button>
              }
              { showClose && 
                <Button className="rounded-circle" variant="light" size="sm" title="Close information bar" onClick={onClose} style={{cursor:'pointer', height:'30px', width:'30px'}}>
                  <FontAwesomeIcon icon={side === "left" ? faChevronLeft : faChevronRight} />
                </Button>
              }
            </div>
          </div>
          <div className="text-xs text-muted" style={{fontSize:'0.65rem', lineHeight:'0.75rem', paddingLeft:'10px'}}>{field?.farm ? field.farm.name : ""}</div>
        </>
      }
      <div className="flex-grow-1 pt-0 pb-2 px-2 pt-2 overflow-auto" style={{flexBasis: 0}}>
        {children}
      </div>
    </div>
  );
};

export default memo(InfoDrawer);